export const itemModel = {
  name: "Dumny item name",
  id: 32435,
  thumbnail:
    "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
  sizes: [
    { name: "Small", add: 0, id: 1 },
    { name: "Medium", add: 7, id: 2 },
    { name: "Large", add: 8, id: 3 }
  ],
  customize: [
    { name: "no onions", add: 0, id: 1 },
    { name: "no tomatos", add: 7, id: 2 },
    { name: "no cheese", add: 8, id: 3 }
  ]
};

export const resturant = {
  name: "dummy resturant name",
  thumbnail:
    "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
  categories: [
    {
      name: "Main Dishes 1",
      id: 1,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 2",
      id: 2,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 3",
      id: 3,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 4",
      id: 4,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 5",
      id: 5,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 6",
      id: 6,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 7",
      id: 7,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 8",
      id: 8,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 9",
      id: 9,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 10",
      id: 10,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 11",
      id: 11,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 12",
      id: 12,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    },
    {
      name: "Main Dishes 13",
      id: 13,
      items: [
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 1
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 2
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 3
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 4
        },
        {
          name: "piza",
          thumbnail:
            "https://www.delonghi.com/Global/recipes/multifry/pizza_fresca.jpg",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio ipsum dolor sit amet consectetur adipisicing elit. Laborum, odio..",
          price: 30,
          id: 5
        }
      ]
    }
  ]
};

export const plans = [
  {
    id: 1,
    name: "free plan",
    price: 0,
    features: [
      {
        name: "PDF Menu",
        avail: true
      },
      {
        name: "Customize menu",
        avail: false
      },
      {
        name: "Modifiers",
        avail: false
      },
      {
        name: "Online payment",
        avail: false
      },
      {
        name: "Table specific ordering",
        avail: false
      }
    ]
  },
  {
    id: 2,
    name: "starter plan",
    price: 25,
    features: [
      {
        name: "PDF Menu",
        avail: true
      },
      {
        name: "Customize menu",
        avail: true
      },
      {
        name: "Modifiers",
        avail: true
      },
      {
        name: "Online payment",
        avail: false
      },
      {
        name: "Table specific ordering",
        avail: false
      }
    ]
  },
  {
    id: 3,
    name: "full plan",
    price: 49,
    features: [
      {
        name: "PDF Menu",
        avail: true
      },
      {
        name: "Customize menu",
        avail: true
      },
      {
        name: "Modifiers",
        avail: true
      },
      {
        name: "Online payment",
        avail: false
      },
      {
        name: "Table specific ordering",
        avail: false
      }
    ]
  },
  {
    id: 4,
    name: "premium",
    price: 79,
    features: [
      {
        name: "PDF Menu",
        avail: true
      },
      {
        name: "Customize menu",
        avail: true
      },
      {
        name: "Modifiers",
        avail: true
      },
      {
        name: "Online payment",
        avail: false
      },
      {
        name: "Table specific ordering",
        avail: false
      }
    ]
  }
];
